/**
 * Onboarding Flow State
 *
 * Initial state and state type for the onboarding flow.
 * Separated for clarity and reusability.
 */

import type { OnboardingState } from '@/features/onboarding/types/onboarding.types';

export const initialOnboardingState: OnboardingState = {
  // Flow not started yet
  hasStarted: false,
  flowStatus: null,
  hasAlternative: false,
  currentFactorType: null,
  currentStepMetadata: null,
  factors: [],
  canComplete: false,
  alternatives: [],

  // SMS/OTP data
  phoneNumberObfuscated: null,
  smsResendCount: 0,
  smsResendCountdown: 0,

  // Primary factor
  primaryFactorType: null,

  // Secondary factors
  activeSecondaryDialog: null,

  // Enrolled factors for summary
  enrolledFactors: [],

  // UI state
  isLoading: false,
  error: null,

  // JWT Exchange state
  exchangeToken: null,
  isExchanging: false,
  isAuthenticated: false,
  exchangeError: null,
  sessionTtl: null,
};
